export default {
    GET_ROUTE (state) {
        return state.route;
    },
    GET_DRAWER (state) {
        return state.drawer;
    },
    GET_LOADING (state) {
        return state.loading
    },
    GET_PAGE_LOADING (state) {
        return state.page_loading
    },
    GET_USER (state) {
        return state.user
    },
    GET_ALERT (state) {
        return state.alert
    },
    GET_AUTHORIZATION (state) {
        return state.authorization
    },
    GET_MAILS (state) {
        return state.mails
    },
    GET_UNREAD (state) {
        return state.unread
    }
}
